import React, { } from "react";
import { } from 'react-redux';
import { } from "react-i18next";

import {
  Tooltip
} from '@lockerpm/design';

import {
  InfoCircleOutlined
} from '@ant-design/icons'

const OnboardingTooltip = (props) => {
  const {
    title = '',
    className = '',
    placement = 'bottom',
    width = 'auto',
    content,
  } = props

  return (
    <Tooltip
      title={title}
      placement={placement}
      overlayStyle={{
        width: width
      }}
    >
      { content || <InfoCircleOutlined className={className}/> }
    </Tooltip>
  );
}

export default OnboardingTooltip;